import React from 'react';
import { FontWeightType, HeadingLarge, LabelMedium } from '../../../component/Text';
import { FadeInDirectionType, FadeWrapper } from '../../../component/animation/animationWrapper';
import { useMobile } from '../../../hook/usePlatform';

const ManagerGreetings : React.FC = () => {
  const isMobile = useMobile();
  return (
    <div style={{
      height: '100%',
      flex: 1,
      paddingBlock: 16,
    }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: isMobile ? 'flex-start' : 'flex-end',
          paddingBlock: isMobile ? 0 : 160,
          paddingInline: 30,
        }}
      >
        <div style={{ paddingInlineStart: isMobile ? 0 : 64 }}>
          <HeadingLarge fontWeight={FontWeightType.w700}>
            살아오며 쌓아온 경험과
          </HeadingLarge>
          <HeadingLarge fontWeight={FontWeightType.w700}>
            기억은 우리의 인생을
          </HeadingLarge>
          <HeadingLarge fontWeight={FontWeightType.w700}>
            더욱 깊고 풍성하게 만듭니다.
          </HeadingLarge>
          <div style={{ height: isMobile ? 12 : 64 }} />
          <FadeWrapper
            direction={FadeInDirectionType.rtl}
            fadeInDistance={10}
            delay={0.5}
            style={{
              paddingInlineEnd: isMobile ? 0 : 64,
            }}
          >
            <LabelMedium style={{ whiteSpace: 'pre-line', fontFamily: 'inter' }}>
              그리고 그 모든 순간을 이해하고 함께 나눌 수 있는 특별한 사람을 찾고 싶다는 마음이 생길 때가 있습니다.
              {'\n\n'}
              저희 &apos;시럽 인연&apos;은 긴 여정을 걸어온 당신을 위해 존재합니다.
              {'\n\n'}
              삶의 깊이를 존중하며, 마음이 닿을 수 있는 사람을 만날 기회를 제공하는 것, 그리고 서로의 이야기가 더 큰 행복으로 이어지도록 돕는 것이 우리의
              역할입니다.
              {'\n\n'}
              단순한 만남이 아닌, 서로의 가치를 이해하고
              {'\n'}
              공감하며 함께할 수 있는 인연을 찾아가는 길.
              {'\n\n'}
              그 여정에 저희가 함께하겠습니다.
              {'\n'}
              당신의 삶이 또 다른 설렘과 따뜻함으로 가득 차길
              {'\n'}
              진심으로 바랍니다.
              {'\n\n'}
              이제 새로운 만남을 시작하세요.
              {'\n'}
              당신의 행복을 위해 저희가 곁에서 도와드리겠습니다.
              {'\n\n'}
              진심을 담아,
              {'\n'}

              <LabelMedium style={{ fontFamily: 'inter' }} fontWeight={FontWeightType.w700}>
                대표이사 김민지
                드림
              </LabelMedium>
            </LabelMedium>

          </FadeWrapper>
        </div>
      </div>
    </div>
  );
};

export default ManagerGreetings;
